import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentVerified = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentVerified' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M7.5,15 L10.5,18 L16.5,12' />
  </StyledIcon>
);
